import { motion } from 'framer-motion'
import styled from 'styled-components'

export const Container = styled(motion.div)`
  width: 100%;
  font-size: 1.1rem;
  margin: 1em 0 0;
`
